import { Controller } from "@hotwired/stimulus"
import { MeiliSearch } from "meilisearch"

// MeiliSearch search with dropdown results (replaces Search.jsx + SearchView.jsx + SearchField.jsx + Store.js + Actions.js)
// Values: minimal (boolean), query
// Targets: input, results
export default class extends Controller {
  static values = { minimal: Boolean, query: String }
  static targets = ["input", "results"]

  connect() {
    const env = document.querySelector('meta[name=env]')?.content || 'development'
    const client = new MeiliSearch({ host: location.protocol + '//' + location.host })
    this.index = client.index('Plant_' + env)

    if (this.queryValue) {
      this.inputTarget.value = this.queryValue
    }
  }

  search() {
    const q = this.inputTarget.value

    if (q === "") {
      this.resultsTarget.innerHTML = ""
      return
    }

    this.index.search(q, { hitsPerPage: 10 }).then((result) => {
      this.renderHits(result.hits, q)
    })
  }

  renderHits(hits, q) {
    if (hits.length === 0 && q) {
      this.resultsTarget.innerHTML = `<div class="dropdown input-search-result"><small>Nothing found. <a href="/plants/new">Add plant</a></small></div>`
      return
    }

    if (hits.length > 0) {
      this.resultsTarget.innerHTML = `<div class="dropdown">${hits.map(hit => this.renderHit(hit)).join("")}</div>`
    } else {
      this.resultsTarget.innerHTML = ""
    }
  }

  renderHit(plant) {
    const name = plant.type === "Variety" ? plant.parent_name + ' "' + plant.name + '"' : plant.name
    const title = name + " - " + plant.scientific_name + " (" + plant.type + ")"
    const tag = plant.type === "Variety"
      ? '<div class="tag-var">Variety</div>'
      : '<div class="tag-sp">Species</div>'

    if (this.minimalValue) {
      return `<a data-turbo="false" class="input-search-result -sm" href="${plant.link}" title="${this.escapeHtml(title)}">
        <label class="input-search-result-name"> ${this.escapeHtml(name)} ${tag}<span>${this.escapeHtml(plant.scientific_name)}</span></label>
      </a>`
    } else {
      return `<a data-turbo="false" class="input-search-result" href="${plant.link}" title="${this.escapeHtml(title)}">
        <img class="data-img-xs" src="${plant.thumb || ''}" />
        <label class="input-search-result-name"> ${this.escapeHtml(name)} ${tag}<span>${this.escapeHtml(plant.scientific_name)}</span></label>
      </a>`
    }
  }

  submitSearch() {
    const q = this.inputTarget.value
    if (q) {
      Turbo.visit("/search?q=" + encodeURIComponent(q))
    }
  }

  escapeHtml(str) {
    if (!str) return ""
    const div = document.createElement("div")
    div.textContent = str
    return div.innerHTML
  }
}
